export interface Article {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  content: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'getting-started-guide',
    title: '91c新手入门完全指南：从零开始掌握核心操作',
    category: 'tutorials',
    excerpt: '本指南将带您从零开始，逐步了解91c平台的全部基础操作，包括账号注册、界面导航、核心功能使用等，让您快速成为91c的熟练用户。',
    content: `<p>欢迎来到91c！作为您值得信赖的首选平台，91c致力于为用户提供全方位的优质服务体验。本指南将带您深入了解91c的核心操作流程。</p>

<h2>第一步：账号注册与设置</h2>
<p>访问91c官网首页，点击右上角的注册按钮，填写您的基本信息即可完成注册。我们建议您完善个人资料，以便获得更加个性化的服务推荐。</p>
<p>注册完成后，您可以在设置页面调整通知偏好、隐私选项以及界面主题，打造专属于您的91c使用环境。</p>

<h2>第二步：界面导航概览</h2>
<p>91c的界面设计遵循简洁直观的原则。顶部导航栏包含了所有主要功能入口，左侧边栏则提供了快捷访问常用功能的通道。首页的信息流会根据您的使用习惯智能推荐相关内容。</p>

<h2>第三步：核心功能使用</h2>
<p>91c的核心功能涵盖数据处理、智能分析、内容管理等多个维度。每个功能模块都配有详细的使用说明和操作提示，确保您能够轻松上手。</p>
<p>我们特别推荐您先尝试数据看板功能，它能够帮助您快速了解平台的各项数据指标和使用情况。</p>

<h2>第四步：进阶技巧</h2>
<p>当您熟悉了基本操作后，可以探索91c的更多进阶功能，如自动化工作流、高级搜索筛选、批量操作等。这些功能将大幅提升您的使用效率。</p>`,
    author: '91c运营团队',
    date: '2026-08-01',
    readTime: '8分钟',
    tags: ['入门', '指南', '新手'],
  },
  {
    slug: 'data-dashboard-feature',
    title: '91c数据看板功能介绍：实时掌握关键指标',
    category: 'features',
    excerpt: '数据看板是91c最受欢迎的功能之一，提供实时数据可视化、自定义图表和智能预警，帮助您轻松掌握业务动态。',
    content: `<p>91c的数据看板功能是平台最核心的能力之一，它将复杂的数据以直观的可视化方式呈现，让您一目了然地掌握各项关键指标。</p>

<h2>实时数据监控</h2>
<p>数据看板支持秒级数据刷新，您可以实时查看各项指标的变化趋势。无论是用户活跃度、内容消费情况还是系统运行状态，都能在第一时间获取最新信息。</p>

<h2>自定义图表配置</h2>
<p>91c提供了丰富的图表类型，包括折线图、柱状图、饼图、热力图等。您可以根据实际需求自由组合和配置，创建专属的数据展示面板。</p>

<h2>智能预警系统</h2>
<p>当关键指标出现异常波动时，91c的智能预警系统会自动触发通知，帮助您在第一时间发现并处理潜在问题。预警规则支持灵活自定义，满足不同场景的需求。</p>

<h2>数据导出与分享</h2>
<p>看板数据支持多种格式导出，方便您进行离线分析或与团队成员分享。同时，您可以将看板设置为公开或私密，灵活控制数据访问权限。</p>`,
    author: '91c产品团队',
    date: '2026-07-28',
    readTime: '6分钟',
    tags: ['数据看板', '功能介绍', '实时监控'],
  },
  {
    slug: 'user-review-roundup-2026',
    title: '2026年度91c用户真实评价汇总：听听他们怎么说',
    category: 'reviews',
    excerpt: '我们收集了2026年度来自不同行业的91c用户真实评价，从使用体验、功能满意度到客服支持，全面了解用户心声。',
    content: `<p>2026年已过半，91c收到了来自全国各地用户的热情反馈。我们整理了部分具有代表性的用户评价，与大家分享。</p>

<h2>企业用户说</h2>
<p>"91c是我们团队协作效率提升的关键工具。数据看板功能让我们能够实时追踪项目进展，智能预警帮助我们在问题出现前就做好预案。" —— 某科技公司项目经理</p>

<h2>个人用户说</h2>
<p>"作为一名自由职业者，91c帮助我更好地管理时间和项目。界面简洁直观，学习成本很低，但功能却很强大。" —— 独立设计师</p>

<h2>教育领域用户说</h2>
<p>"我们在教学中引入了91c作为辅助工具，学生们反馈使用体验很好，特别是数据分析功能让课程变得更加生动有趣。" —— 高校教师</p>

<h2>总体满意度</h2>
<p>根据2026年上半年的用户满意度调查，91c在功能完整性、使用便捷性和客服响应速度三个维度上均获得了4.8分以上的好评（满分5分）。</p>`,
    author: '91c社区团队',
    date: '2026-07-25',
    readTime: '5分钟',
    tags: ['用户评价', '2026', '口碑'],
  },
  {
    slug: 'version-3-5-release',
    title: '91c v3.5版本发布：全新界面与性能大幅提升',
    category: 'versions',
    excerpt: '91c最新版本v3.5正式发布，带来了全新的界面设计、性能优化以及多项用户期待已久的新功能。',
    content: `<p>经过数月的精心打磨，91c v3.5版本终于与大家见面了！本次更新聚焦于用户体验和性能，带来了众多令人期待的改进。</p>

<h2>全新界面设计</h2>
<p>v3.5版本采用了全新的设计语言，界面更加简洁现代。重新设计的导航结构让功能查找更加便捷，信息层级更加清晰合理。</p>

<h2>性能大幅提升</h2>
<p>我们对核心引擎进行了深度优化，页面加载速度提升40%，数据查询响应时间缩短50%。大型数据集的处理性能更是有了质的飞跃。</p>

<h2>新增功能一览</h2>
<ul>
<li>批量数据处理：支持一次性处理大规模数据集</li>
<li>协作功能增强：多人实时协作编辑，变更历史追踪</li>
<li>移动端适配优化：在手机和平板上的使用体验更加流畅</li>
<li>API接口扩展：新增20+数据接口，集成更加便捷</li>
</ul>

<h2>升级方式</h2>
<p>现有用户可以通过设置页面的"检查更新"按钮一键升级至v3.5版本。新用户直接访问91c官网即可体验最新版本。</p>`,
    author: '91c技术团队',
    date: '2026-08-03',
    readTime: '5分钟',
    tags: ['版本更新', 'v3.5', '新功能'],
  },
  {
    slug: 'account-security-faq',
    title: '91c账号安全常见问题解答',
    category: 'faq',
    excerpt: '关于91c账号安全的常见疑问，包括密码管理、双重验证、登录异常处理等，一文为您全面解答。',
    content: `<p>账号安全是每位91c用户最关心的话题之一。我们整理了用户最常咨询的账号安全问题，提供详细解答。</p>

<h2>如何设置强密码？</h2>
<p>建议使用至少12位字符，包含大小写字母、数字和特殊符号的组合。避免使用生日、姓名等容易被猜测的信息。91c在注册时会自动检测密码强度并提供改进建议。</p>

<h2>什么是双重验证？如何开启？</h2>
<p>双重验证是为账号增加额外保护层的重要安全措施。开启后，除了密码外，还需要输入手机验证码或使用认证器应用生成的动态码才能登录。您可以在"账号设置-安全"页面开启此功能。</p>

<h2>发现异常登录怎么办？</h2>
<p>如果您收到陌生设备登录的通知，请立即登录账号，在"安全设置"中查看登录记录，并强制下线所有可疑设备。同时建议立即修改密码并开启双重验证。</p>

<h2>忘记密码如何找回？</h2>
<p>在登录页面点击"忘记密码"，输入注册邮箱或手机号，系统会发送验证码。验证通过后即可重置密码。如果注册信息已失效，请联系客服寻求帮助。</p>`,
    author: '91c安全团队',
    date: '2026-07-20',
    readTime: '6分钟',
    tags: ['账号安全', 'FAQ', '密码'],
  },
  {
    slug: 'smart-analysis-deep-dive',
    title: '91c智能分析引擎深度解析：AI如何驱动决策',
    category: 'features',
    excerpt: '深入了解91c智能分析引擎的工作原理、核心算法和应用场景，看AI技术如何帮助您做出更明智的决策。',
    content: `<p>91c智能分析引擎是平台的技术核心，它融合了机器学习和大数据分析技术，为用户提供深度的数据洞察和决策支持。</p>

<h2>技术架构概览</h2>
<p>智能分析引擎采用了多层架构设计，底层是高效的数据处理管道，中层是算法模型层，上层则是对外提供的分析API和可视化接口。这种架构确保了系统的扩展性和稳定性。</p>

<h2>核心算法能力</h2>
<p>引擎内置了多种先进的算法模型，包括趋势预测、异常检测、关联分析和自然语言处理。这些算法经过大量真实数据的训练和调优，在准确性和效率上都有出色表现。</p>

<h2>典型应用场景</h2>
<p>智能分析引擎已在多个行业中发挥了重要作用：金融领域的风险预测、电商领域的用户行为分析、制造业的生产优化以及医疗领域的健康数据分析等。</p>

<h2>未来展望</h2>
<p>我们正在研发更强大的深度学习模型，预计在年底推出的v4.0版本中，分析引擎的预测准确率将再提升30%，同时将支持更多类型的数据源接入。</p>`,
    author: '91c AI团队',
    date: '2026-07-18',
    readTime: '7分钟',
    tags: ['智能分析', 'AI', '技术深度'],
  },
  {
    slug: 'automation-workflow-tutorial',
    title: '91c自动化工作流设置教程：让重复工作一键完成',
    category: 'tutorials',
    excerpt: '学习如何在91c中创建和配置自动化工作流，将繁琐的重复操作交给系统，释放您的时间和精力。',
    content: `<p>自动化工作流是91c提升效率的利器，通过简单的配置即可让系统自动执行一系列预设操作。本教程将详细介绍如何创建您的第一个自动化工作流。</p>

<h2>什么是自动化工作流</h2>
<p>自动化工作流是一组按特定条件触发的操作序列。当满足预设的触发条件时，系统会自动按照您定义的步骤执行相应的操作，无需人工干预。</p>

<h2>创建您的第一个工作流</h2>
<p>进入自动化中心，点击"新建工作流"，为工作流命名并选择触发条件。例如，您可以设置"每天上午9点自动生成昨日数据报表并发送至指定邮箱"。</p>

<h2>配置操作步骤</h2>
<p>91c提供了丰富的操作选项，包括数据查询、文件生成、邮件发送、消息通知等。通过拖拽式界面，您可以轻松组合这些操作，构建复杂的工作流程。</p>

<h2>测试与发布</h2>
<p>配置完成后，使用"测试运行"功能验证工作流是否按预期执行。确认无误后点击发布，工作流即会开始按照设定的条件自动运行。</p>`,
    author: '91c运营团队',
    date: '2026-07-15',
    readTime: '7分钟',
    tags: ['自动化', '教程', '工作流'],
  },
  {
    slug: 'version-3-4-update',
    title: '91c v3.4版本回顾：协作功能全面升级',
    category: 'versions',
    excerpt: '回顾91c v3.4版本带来的协作功能升级，包括实时协作编辑、评论系统和权限管理的重大改进。',
    content: `<p>在v3.5发布之前，v3.4版本已经为91c的用户协作体验带来了革命性的变化。让我们回顾一下这个重要的里程碑版本。</p>

<h2>实时协作编辑</h2>
<p>v3.4引入了真正的实时协作编辑功能，多人可以同时编辑同一份文档或数据视图，所有更改实时同步。光标位置、编辑者身份等信息清晰可见，让团队协作如同身处同一办公室。</p>

<h2>评论与讨论系统</h2>
<p>全新的评论系统支持在文档、数据看板的任意位置添加评论和讨论。@提及功能可以快速通知相关同事加入讨论，所有讨论记录有序归档便于追溯。</p>

<h2>权限管理升级</h2>
<p>权限粒度从项目级别细化到了模块和字段级别，管理员可以精确控制每个成员的查看和编辑权限。同时新增了临时权限分享功能，方便外部合作伙伴的临时访问。</p>`,
    author: '91c产品团队',
    date: '2026-07-10',
    readTime: '4分钟',
    tags: ['版本回顾', 'v3.4', '协作'],
  },
  {
    slug: 'payment-billing-faq',
    title: '91c付费与账单常见问题',
    category: 'faq',
    excerpt: '关于91c的付费方式、套餐选择、账单管理和退款政策的常见疑问，详细解答助您放心使用。',
    content: `<p>为了让用户更好地了解91c的付费体系，我们整理了关于付费和账单方面最常被问到的问题。</p>

<h2>91c有哪些付费套餐？</h2>
<p>91c目前提供免费版、专业版和企业版三个套餐。免费版包含基础功能，适合个人用户入门体验；专业版提供完整的功能访问，适合高级个人用户和小团队；企业版则为大型组织提供定制化服务。</p>

<h2>支持哪些支付方式？</h2>
<p>我们支持微信支付、支付宝、银联卡以及国际信用卡（Visa、MasterCard）等多种支付方式，方便不同地区的用户进行订阅。</p>

<h2>如何查看和管理账单？</h2>
<p>登录91c后，进入"账号设置-账单管理"页面即可查看所有历史账单和付款记录。您可以在此页面下载发票、修改付款方式或取消自动续费。</p>

<h2>退款政策是怎样的？</h2>
<p>91c提供7天无理由退款保障。如果您在订阅后7天内觉得服务不满足需求，可以联系客服申请全额退款。超过7天的退款请求将根据具体情况评估处理。</p>`,
    author: '91c客服团队',
    date: '2026-07-08',
    readTime: '5分钟',
    tags: ['付费', 'FAQ', '账单'],
  },
  {
    slug: 'small-business-success-story',
    title: '用户故事：小型创业公司如何借助91c实现数据驱动增长',
    category: 'reviews',
    excerpt: '一家初创公司在使用91c后，数据管理效率提升300%，决策速度显著加快。来听听他们的真实经历。',
    content: `<p>今天分享的是一家小型科技创业公司使用91c的真实故事。这家只有12人的团队，在引入91c后实现了令人瞩目的业务增长。</p>

<h2>背景与挑战</h2>
<p>这家公司专注于为企业客户提供SaaS解决方案。业务快速增长的同时，数据分散在多个系统中，团队很难获得统一的业务视图。每周的数据整理和报表制作耗费了大量人力。</p>

<h2>选择91c的原因</h2>
<p>经过多方比较，团队选择了91c。原因有三：一是界面直观易用，团队成员无需培训即可上手；二是数据整合能力强大，可以接入他们使用的所有第三方工具；三是价格合理，对于预算有限的创业公司非常友好。</p>

<h2>使用效果</h2>
<p>引入91c三个月后，数据整理时间从每周8小时缩短至2小时，效率提升300%。更重要的是，团队现在能够基于实时数据快速做出业务决策，客户响应速度也大幅提升。</p>

<h2>团队评价</h2>
<p>"91c改变了我们看待数据的方式。以前数据是负担，现在数据是武器。我们的每一个业务决策都有数据支撑，这在以前是不可想象的。" —— 公司CEO</p>`,
    author: '91c社区团队',
    date: '2026-07-05',
    readTime: '6分钟',
    tags: ['用户故事', '创业', '数据驱动'],
  },
  {
    slug: 'api-integration-guide',
    title: '91c API接口集成完整指南：无缝对接您的技术栈',
    category: 'tutorials',
    excerpt: '详细教程指导开发者如何通过91c的API接口实现与现有系统的无缝集成，包括认证、数据同步和Webhook配置。',
    content: `<p>91c提供了功能强大的RESTful API接口，让开发者可以轻松将91c的能力集成到现有的技术栈中。本指南将带您完成从认证到数据对接的全流程。</p>

<h2>API认证方式</h2>
<p>91c使用基于Token的认证机制。您可以在"开发者设置"页面生成API Token，然后在每个请求的Header中携带该Token即可完成认证。建议为不同的应用创建独立的Token以便管理。</p>

<h2>基础CRUD操作</h2>
<p>91c API提供了完整的数据增删改查接口。所有接口遵循RESTful规范，返回标准JSON格式的数据。接口文档中详细列出了每个端点支持的参数和返回的数据结构。</p>

<h2>数据同步策略</h2>
<p>对于需要实时数据同步的场景，我们推荐使用91c的Webhook功能。您可以在系统中配置事件监听，当数据发生变化时，91c会自动向您指定的URL发送通知。</p>

<h2>最佳实践</h2>
<p>在使用91c API时，建议实现请求重试机制、合理的调用频率控制和完善的错误处理逻辑。同时，请妥善保管您的API Token，避免在客户端代码中暴露。</p>`,
    author: '91c开发者团队',
    date: '2026-07-02',
    readTime: '9分钟',
    tags: ['API', '集成', '开发者'],
  },
  {
    slug: 'mobile-experience-faq',
    title: '91c移动端使用常见问题',
    category: 'faq',
    excerpt: '关于91c移动端App和移动网页版的常见使用问题，包括下载安装、功能差异和离线使用等。',
    content: `<p>随着移动办公的普及，越来越多的用户选择在手机和平板上使用91c。以下是关于移动端使用的热门问题解答。</p>

<h2>91c有移动App吗？如何下载？</h2>
<p>有的！91c提供了iOS和Android两个平台的官方App。您可以在App Store或各大安卓应用商店搜索"91c"下载。移动App针对触屏操作进行了深度优化，提供流畅的手势操作体验。</p>

<h2>移动端和桌面端功能有差异吗？</h2>
<p>移动端覆盖了桌面端90%以上的核心功能。部分高级配置和复杂的数据处理操作建议在桌面端完成。两个平台之间的数据完全同步，切换使用毫无障碍。</p>

<h2>可以离线使用吗？</h2>
<p>91c移动App支持离线模式。您可以在有网络时将需要的数据缓存到本地，在无网络环境下查看和编辑。恢复网络后，所有离线修改会自动同步到云端。</p>

<h2>移动端数据安全吗？</h2>
<p>移动端采用了与桌面端同等级别的安全保护措施，包括数据传输加密、本地数据加密存储和生物识别解锁等功能，全方位保障您的数据安全。</p>`,
    author: '91c移动团队',
    date: '2026-06-28',
    readTime: '5分钟',
    tags: ['移动端', 'FAQ', 'App'],
  },
  {
    slug: 'enterprise-deployment-case',
    title: '用户案例：大型企业如何通过91c实现数字化转型',
    category: 'reviews',
    excerpt: '某500强企业使用91c企业版实现了数据治理和业务流程优化，数字化转型取得显著成效。',
    content: `<p>在数字化转型浪潮中，越来越多的传统大型企业开始借助91c等工具实现业务升级。本文分享一家制造业500强企业的成功实践。</p>

<h2>转型背景</h2>
<p>该企业拥有遍布全国的多个生产基地和数千名员工。在转型前，各厂区的数据标准不统一，信息传递滞后，管理决策缺乏实时数据支撑。</p>

<h2>解决方案</h2>
<p>91c企业版为该企业量身定制了数据中台解决方案。通过统一的数据接入标准、实时的数据看板和智能预警系统，企业实现了从"经验决策"到"数据决策"的转变。</p>

<h2>实施成果</h2>
<p>项目实施半年后，数据报表生成时间从3天缩短至实时展现，异常事件响应时间从小时级降至分钟级，整体运营效率提升25%。</p>

<h2>持续优化</h2>
<p>目前该企业正在与91c合作推进第二阶段的数字化升级，计划将AI预测能力应用到供应链优化和生产排程等核心业务场景中。</p>`,
    author: '91c企业服务团队',
    date: '2026-06-25',
    readTime: '6分钟',
    tags: ['企业案例', '数字化转型', '用户故事'],
  },
  {
    slug: 'data-export-advanced',
    title: '91c数据导出高级技巧：灵活掌控数据输出',
    category: 'features',
    excerpt: '掌握91c的数据导出高级功能，包括自定义导出模板、定时导出任务和多格式支持，让数据输出更加灵活高效。',
    content: `<p>91c的数据导出功能远不止简单的CSV下载，它提供了丰富的自定义选项和自动化能力，满足各种复杂的数据输出需求。</p>

<h2>自定义导出模板</h2>
<p>您可以创建并保存专属的数据导出模板，定义需要导出的字段、过滤条件、排序规则和格式设置。一次配置，多次复用，大大提高数据导出效率。</p>

<h2>定时导出任务</h2>
<p>对于需要定期生成报表的场景，可以在91c中设置定时导出任务。指定导出频率（每日、每周、每月）、输出格式和接收邮箱，系统会自动按计划执行。</p>

<h2>多格式支持</h2>
<p>除了常见的CSV和Excel格式，91c还支持JSON、XML、PDF等格式导出。对于API集成场景，JSON格式尤为方便；对于正式报告，PDF格式则更加专业美观。</p>

<h2>大数据量处理</h2>
<p>当数据量超过百万行时，91c会自动启用分片导出机制，将数据分割为多个文件打包下载，并支持断点续传，确保大规模数据导出的稳定可靠。</p>`,
    author: '91c产品团队',
    date: '2026-06-20',
    readTime: '5分钟',
    tags: ['数据导出', '高级技巧', '功能介绍'],
  },
  {
    slug: 'version-roadmap-2026',
    title: '91c 2026下半年版本路线图前瞻',
    category: 'versions',
    excerpt: '揭秘91c在2026年下半年的产品规划，包括AI助手、第三方集成市场、全新移动端体验等重磅更新。',
    content: `<p>2026年上半年91c已完成多次重要更新，下半年我们还有更多令人兴奋的计划。以下是91c 2026下半年的版本路线图概览。</p>

<h2>Q3：AI智能助手</h2>
<p>计划在9月推出AI智能助手功能，用户可以通过自然语言与91c交互，用对话的方式完成数据分析、报表生成等操作，大幅降低使用门槛。</p>

<h2>Q3：第三方集成市场</h2>
<p>同步推出91c集成市场，汇集经过认证的第三方插件和集成方案。用户可以一键安装所需插件，扩展91c的功能边界。</p>

<h2>Q4：全新移动端体验</h2>
<p>年底前将发布全新设计的移动端App，采用原生开发架构，性能和体验将有质的飞跃。同时新增离线AI分析等前沿功能。</p>

<h2>Q4：企业版专属功能</h2>
<p>企业版将新增单点登录(SSO)、审计日志、合规性报告等企业级功能，满足大型组织的安全和合规需求。</p>`,
    author: '91c产品团队',
    date: '2026-08-04',
    readTime: '5分钟',
    tags: ['版本路线图', '2026', '前瞻'],
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.category === categorySlug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getLatestArticles(count: number): Article[] {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
}